<!-- Start Containerbar -->
<div id="containerbar" class="containerbar authenticate-bg">
  <!-- Start Container -->
  <p-toast></p-toast>
  <div class="container">
    <div class="auth-box login-box">
      <!-- Start row -->
      <div class="row no-gutters align-items-center justify-content-center">
        <!-- Start col -->
        <div class="col-md-6 col-lg-5">
          <!-- Start Auth Box -->
          <div class="auth-box-right">
            <div class="card">
              <div class="card-body">
                <div class="form-head">
                  <a href="index.html" class="logo"
                    ><img
                      src="assets/images/logo.svg"
                      class="img-fluid"
                      alt="logo"
                  /></a>
                </div>
                <h4 class="text-primary my-4">Account Information</h4>

                <form
                  class="noti-form"
                  [formGroup]="notiForm"
                  (ngSubmit)="onSave()"
                >
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      id="username"
                      placeholder="Enter your Email Address"
                      required
                      formControlName="email"
                      [ngClass]="{
                        'is-invalid': submitted && f.email.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && f.email.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.email.errors.required">
                        Please enter Your Email
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <input
                      id="offline"
                      type="text"
                      class="form-control"
                      id="password"
                      placeholder="Enter Colleague's Email Address"
                      required
                      formControlName="colleagueEmail"
                      [ngClass]="{
                        'is-invalid': submitted && f.colleagueEmail.errors
                      }"
                    />
                    <div
                      *ngIf="submitted && f.colleagueEmail.errors"
                      class="invalid-feedback"
                    >
                      <div *ngIf="f.colleagueEmail.errors.required">
                        Please enter Colleague email address
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary-rgba btn-lg btn-block font-18"
                    [disabled]="disableBtn"
                  >
                    Send OTP
                  </button>
                </form>
              </div>
            </div>
          </div>
          <!-- End Auth Box -->
        </div>
        <!-- End col -->
      </div>
      <!-- End row -->
    </div>
  </div>
  <!-- End Container -->
</div>
<!-- End Containerbar -->
